import DynamicPageRenderer from "../../components/DynamicPageRenderer";

const Origines = () => {
  return <DynamicPageRenderer slug="histoire/origines" />;
};

export default Origines;
